export const accordionReady = () => {
	document.querySelectorAll('.accordion').forEach((element) => {
		element.addEventListener('click', toggleAccordion);
	});
};

const toggleAccordion = (event) => {
	const accordion = event.currentTarget;
	const accordionId = accordion.getAttribute('data-accordion');

	if (accordion.classList.contains('active')) {
		resetAccordion();
	} else {
		resetAccordion();
		if (!accordion.classList.contains('active')) {
			accordion.classList.add('active');
			accordion.querySelector('span.active-icon').innerHTML = '-';
		}
		document
			.querySelector(`#accordion-description-${accordionId}`)
			.classList.toggle('max-h-0');
		document
			.querySelector(`#accordion-description-${accordionId}`)
			.classList.toggle('max-h-96');
	}
};

const resetAccordion = () => {
	document.querySelectorAll('.accordion').forEach((element) => {
		if (element.classList.contains('active')) {
			element.classList.remove('active');
			element.querySelector('span.active-icon').innerHTML = '+';
		}
	});
	document.querySelectorAll('.accordion-description').forEach((element) => {
		if (!element.classList.contains('max-h-0')) {
			element.classList.add('max-h-0');
			element.classList.remove('max-h-96');
		}
	});
};
